export default __webpack_public_path__ + "static/media/example-src-2.d3ec2e92.webp";